// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--p8bAB","input":"input--wkdn6"};